import PropTypes from "prop-types";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Icon from "@mui/material/Icon";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function FilledImageCard({ variant, color, image, title, description, action, producto, width }) {
  const buttonStyles = {
    width: "max-content",
    display: "flex",
    alignItems: "center",

    "& .material-icons-round": {
      fontSize: "1.125rem",
      transform: `translateX(3px)`,
      transition: "transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)",
    },

    "&:hover .material-icons-round, &:focus .material-icons-round": {
      transform: `translateX(6px)`,
    },
  };

  return (
    <MKBox
      display={{ xs: "block", md: "flex" }}
      variant={variant}
      bgColor={variant === "contained" ? "grey-100" : color}
      borderRadius="xl"
      pt={3.5}
      pb={3}
      px={3}
    >
      <Container>
        <Grid container item xs={12} justifyContent="center" mx="auto">
          <Grid item xs={12} lg={12}>
            <MKBox
              component="img"
              src={image}
              alt={title}
              my="auto"
              opacity={1}
              style={{display: "flex"}}
              sx={{
                  maxWidth: width,
                  height: 'auto',
                  display: 'block',
                  margin: '0 auto'
              }}
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <MKBox pt={{ xs: 3, md: 0 }} pl={{ xs: 0, md: 2 }} lineHeight={1}>
              <MKTypography
                display="block"
                variant="5"
                color={variant === "contained" || color === "light" ? "dark" : "white"}
                fontWeight="bold"
                mb={1}
              >
                {title}
              </MKTypography>
              <MKTypography
                display="block"
                variant="body2"
                color={variant === "contained" || color === "light" ? "text" : "white"}
                mb={2}
              >
                {description}
              </MKTypography>
              <MKTypography
                variant="body2"
                fontWeight="regular"
                color={variant === "contained" ? color : "white"}
                sx={buttonStyles}
              >
                <Link
                  to="/producto/detalle"
                  state={{ producto }}
                >
                  {action.label} <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
                </Link>
              </MKTypography>
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

// Typechecking props for the FilledInfoCard
FilledImageCard.propTypes = {
  variant: PropTypes.oneOf(["contained", "gradient"]),
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  image: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  action: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      label: PropTypes.string.isRequired,
    }),
  ]),
  producto: PropTypes.any,
  width: PropTypes.string
};

export default FilledImageCard;
